import { BaseElement, defineElement } from '@webtides/element-js';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock/lib/bodyScrollLock.es6';

class HeaderArea extends BaseElement {
    connected() {
        this.evaluateFlyoutHeight();
        this.setCssProperties();
        this.lastScrollTop = window.scrollY;
        document.addEventListener('scroll', () => this.hasScrolled(window.scrollY), { passive: true });
        this.querySelectorAll('.level-2-wrapper').forEach((el) => el.removeAttribute('cloak'));
        this.menuLevel1 = this.$refs.level1.querySelectorAll('.level-1-item');
        this.menuLevel2 = this.$refs.level1.querySelectorAll('.level-2');
    }

    properties() {
        return {
            menuOpen: false,
            menuLevel1: [],
            menuLevel2: [],
        };
    }

    watch() {
        return {
            menuOpen: (open) => {
                this.$refs.mainNavigation.classList.toggle('is-open', open);
                if (open) {
                    disableBodyScroll(this.$refs.level1);
                } else {
                    enableBodyScroll(this.$refs.level1);
                }
            },
        };
    }

    evaluateFlyoutHeight() {
        let flyoutTotalHeight = 0;
        this.querySelectorAll('.level-2-wrapper').forEach((flyout) => {
            flyoutTotalHeight = flyout.offsetHeight > flyoutTotalHeight ? flyout.offsetHeight : flyoutTotalHeight;
        });

        return flyoutTotalHeight;
    }

    setCssProperties() {
        if (!this.classList.contains('is-sticky')) {
            this.height = this.offsetHeight;
            this.style.setProperty(`--header-height`, `${this.height}px`);
        }
        this.style.setProperty(`--header-content-height`, `${this.$refs.content.offsetHeight}px`);

        let flyoutHeight = this.evaluateFlyoutHeight();
        this.style.setProperty(`--level-2-wrapper-height`, `${flyoutHeight}px`);

        const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        document.documentElement.style.setProperty('--scroll-bar-width', scrollbarWidth + 'px');
        document.documentElement.style.setProperty('--header-height', this.height + 'px');
    }

    events() {
        return {
            window: {
                resize: () => this.setCssProperties(),
            },
            this: {
                transitionend: () => this.setCssProperties(),
            },
            '[ref=mainNavigation]': {
                click: (e) => {
                    if (this.menuOpen && this.$refs.closeMenuBtn.contains(e.target)) {
                        this.menuOpen = false;
                    }
                },
                mouseenter: () => this.$refs.content.classList.add('show-accent-line'),
                mouseleave: () => this.$refs.content.classList.remove('show-accent-line'),
            },
            '[ref=menuBtn]': {
                click: () => {
                    this.menuOpen = true;
                    this.resetMenuLevel1();
                },
            },
            '[ref=closeMenuBtn]': {
                click: () => {
                    this.menuOpen = false;
                    this.reset = true;
                    this.$refs.backMenuBtn.classList.add('hidden');
                    this.resetMenuLevel1();
                    this.closeMenuLevel2();
                },
            },
            '[ref=backMenuBtn]': {
                click: () => {
                    this.$refs.backMenuBtn.classList.add('hidden');
                    this.resetMenuLevel1();
                    this.closeMenuLevel2();
                },
            },

            '.level-link': {
                click: (e) => {
                    e.target.classList.toggle('is-open');
                },
            },

            '.level-1-item': {
                click: (e) => {
                    if (e.target.classList.contains('level-1-item')) {
                        this.hideMenuLevel1Siblings(e.target);
                        this.$refs.backMenuBtn.classList.remove('hidden');
                        e.target.classList.add('is-open');
                    }
                },
            },
            '.level-2': {
                click: (e) => {
                    e.currentTarget.classList.toggle('is-open');
                },
            },
        };
    }
    resetMenuLevel1() {
        this.menuLevel1.forEach((item) => {
            item.classList.remove('hidden');
            item.classList.remove('is-active');
            item.classList.remove('is-open');
        });
    }

    closeMenuLevel2() {
        this.menuLevel2.forEach((item) => {
            item.classList.remove('is-open');
        });
    }

    hideMenuLevel1Siblings(elem) {
        this.menuLevel1 = [];
        const currentElement = elem;
        elem = elem.parentNode.firstChild;
        do {
            if (elem.nodeType === 3) continue; // text node
            if (elem !== currentElement) {
                elem.classList.add('hidden');
            }
            this.menuLevel1.push(elem);
        } while ((elem = elem.nextSibling));
        return this.menuLevel1;
    }

    hasScrolled(scrollY) {
        const scrollUp = scrollY < this.lastScrollTop;
        const isSticky = scrollUp ? scrollY !== 0 : scrollY > this.height;
        this.classList.toggle('is-sticky', isSticky);
        this.classList.toggle('is-down', scrollUp);
        this.classList.toggle('is-up', !scrollUp);

        this.lastScrollTop = scrollY;
    }
}

export function define() {
    defineElement('header-area', HeaderArea);
}
